import Text from 'components/corporatiu/Text';
import Titol from 'components/corporatiu/Titol';
import __isEmpty from 'lodash/isEmpty';
import styles from './valors.module.scss';
import Imatge from 'components/corporatiu/Imatge/Imatge';

export default function Valors(props) {
    const { items } = props;

    return (
        <>
            <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
            <video
                controls={true}
                muted={true}
                preload={true}
                loop={true}
                className={styles.valorsVideo}
                poster='https://img.3cat.cat/multimedia/png/1/3/1751614373931.png'
            >
                <source
                    src='https://statics.3cat.cat/multimedia/mp4/8/9/1751618254298.mp4'
                    media='(min-width: 568px)'
                    type='video/mp4'
                />
                <source
                    src='https://statics.3cat.cat/multimedia/ogv/4/2/1751618213924.ogv'
                    media='(max-width: 567px)'
                    type='video/ogg'
                />
                <small>Actualitza el teu navegador per visualitzar aquest vídeo.</small>
            </video>
            <Text text={items?.intro} className={styles.intro} />
            <div>
                {!__isEmpty(items) &&
                    items?.valors.map((item, index) => (
                        <div key={index}>
                            <div key={`valor-${index}`} className={styles.valorWrapper}>
                                {item?.imatge && (
                                    <div className={styles.imatgeWrapper}>
                                        <Imatge
                                            src={item?.imatge}
                                            className={styles.imatge}
                                            width={125}
                                            height={125}
                                            priority={false}
                                            alt={item?.['alt_imatge']}
                                        />
                                        <Text text={item?.titol} className={styles.valor} tag='h2' />
                                    </div>
                                )}
                                <Text text={item?.text} className={styles.valorText} />
                            </div>
                        </div>
                    ))}
            </div>
        </>
    );
}
